import { h, Component } from 'preact';
import React from 'react';
import { showPopup } from '../helpers'
import Cookies from 'js-cookie'
import { isMobile, isProductPage, isCartPage } from '../helpers'

class TimedOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      cookieName: 'mfDontShowOverlay',
      products: props.products
    }
  }

  componentDidMount() {
    const userSettings = this.props.userSettings
    if (!Cookies.get(this.state.cookieName)) {
      const showOverlay = isMobile() && ((isProductPage(userSettings) && userSettings.product_timed_overlay) ||
                                         (isCartPage() && userSettings.cart_timed_overlay))
      setTimeout(() => {
        this.setState({ showOverlay })
      }, userSettings.popup_timer_delay * 1000);
    }
  }

  timedOverlayStyles() {
    const userSettings = this.props.userSettings
    return {
      position: 'fixed',
      top: userSettings.timed_overlay_position == 'bottom' ? '' : 0,
      left: 0,
      // height: '68px',
      opacity: userSettings.timed_overlay_opacity,
      bottom: userSettings.timed_overlay_position == 'bottom' ? 0 : '',
      zIndex: 99999999999,
      width: '100%',
      textAlign: 'left',
      padding: '5px 10px',
      backgroundColor: userSettings.timed_overlay_background_color,
      boxShadow: '0px 1px 9px #555',
      color: userSettings.timed_overlay_font_color
    }
  }

  textStyles() {
    return {
      display: 'inline-block',
      float: 'left',
      fontWeight: 'bold',
      fontSize: '14px',
      marginTop: '19px',
      lineHeight: '20px',
    }
  }

  linkStyles() {
    const userSettings = this.props.userSettings
    return {
      color: userSettings.timed_overlay_font_color,
      border: `1px solid ${userSettings.timed_overlay_font_color}`,
      display: 'inline-block',
      textAlign: 'left',
      fontSize: '13px',
      lineHeight: 2,
      margin: '10px',
      padding: '5px 10px',
      float: 'left',
      borderRadius: '3px'
    }
  }

  closeStyles() {
    const userSettings = this.props.userSettings
    return {
      color: userSettings.timed_overlay_font_color,
      fontSize: '28px',
      fontWeight: 'bold',
      verticalAlign: 'middle',
      lineHeight: 1,
      float: 'right',
      margin: '11px 5px',
    }
  }

  closeOverlay() {
    this.setState({ showOverlay: false })
    Cookies.set(this.state.cookieName, true, { expires: 1 });
  }

  openPopup() {
    this.setState({ showOverlay: false })
    showPopup()
  }

  render(props, state) {
    if (state.products.length && state.showOverlay) {
      return (
        <div class="timed-overlay" style={this.timedOverlayStyles()}>
          <span class="timed-overlay-text" style={this.textStyles()}>{props.userSettings.timed_overlay_text}</span>
          <a onClick={() => this.openPopup()} style={this.linkStyles()}>
            {props.userSettings.timed_overlay_button_text || 'Make an Offer'}
          </a>
          <span className="close" style={this.closeStyles()} onClick={() => this.closeOverlay()}>×</span>
        </div>
      )
    }
  }
}

export default TimedOverlay;
